import { gql } from '@apollo/client';

export const CREATE_CATEGORY = gql`
mutation CreateCategory($input: CreateCategoryInput!) {
  createCategory(input: $input) {
    id
    name
    image
    createdAt
    updatedAt
  }
}`;

export const UPDATE_CATEGORY = gql`
mutation UpdateCategory($updateCategoryId: ID!, $input: UpdateCategoryInput!) {
  updateCategory(id: $updateCategoryId, input: $input) {
    id
    name
    image
    createdAt
    updatedAt
  }
}`;

export const DELETE_CATEGORY = gql`
mutation DeleteCategory($deleteCategoryId: ID!) {
  deleteCategory(id: $deleteCategoryId)
}`;

export const GET_ALL_CATEGORIES = gql`
query GetAllCategories {
  getAllCategories {
    id
    name
    image
    createdAt
    updatedAt
  }
}`;
